import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuDetailsTarificationsService } from './services/menu-details-tarifications.service';
import { MenuDetailsTarificationsComponent } from './menu-details-tarifications.component';
import { ButtonModule } from "libraries/module/formbuilder/fields/button/button.module";
import { BtnModule } from "libraries/ui_button/btn.module";
import { PermissionModule } from "../../permission/permission.module";

@NgModule({
    imports: [
        CommonModule,
        PermissionModule,
        ButtonModule,
        BtnModule
    ],
    exports: [
        MenuDetailsTarificationsComponent,
    ],
    declarations: [
        MenuDetailsTarificationsComponent,
    ],
    providers: [
        MenuDetailsTarificationsService,
    ],
})
export class MenuDetailsTarificationsModule {
}
